import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';

@Component({
  selector: 'app-apptakeover-setup',
  templateUrl: './apptakeover-setup.component.html',
  styleUrls: ['./apptakeover-setup.component.scss']
})
export class ApptakeoverSetupComponent implements OnInit {

   config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows
  };


  createConfigFlag:boolean = true;
  whitelistFlag : boolean = false;
  localFlagsData: any;
  localData: any;
  zoneData: any = [];
  whitelistObj:any;

  constructor(
    private wizardService: NgWizardService,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration
  ) {
    this.localFlagsData = JSON.parse(localStorage.getItem('appTakeoverStepFlags'))
    this.localData = JSON.parse(localStorage.getItem('appTakeoverList'))
   }

  ngOnInit() {
    if(this.localData.is_edit){
      this.createConfigFlag = this.localFlagsData.createConfigFlag
      this.whitelistFlag = this.localFlagsData.whitelistFlag
      // this.engagementId = this.localData.task_id
      // this.engagementType = this.localData.engagement_type_id
      this.configCreated(true)
      console.log(this.whitelistFlag);
      
    }
  }

  configCreated(e){
    this.whitelistFlag = true;
      setTimeout(()=>{
        this.wizardService.next();
      },500)
  }

  getWhitelistObj(e) {
    this.whitelistObj = e;
    this.fetchZoneTypeData(e.wts_type);
  }


  fetchZoneTypeData(wts_type) {
    console.log(wts_type);
    
    if (wts_type == 1) {
      this.apiService.get(this.apiConfig.configGetRegion).subscribe((res) => {
        this.zoneData = res["data"].region;
        console.log("regionData", this.zoneData);
      });
    } else if (wts_type == 2) {
      this.apiService.get(this.apiConfig.configGetStates).subscribe((res) => {
        this.zoneData = res["data"].state;
        console.log("SateData", this.zoneData);
      });
    } else if (wts_type == 3) {
      this.apiService.get(this.apiConfig.configGetCities).subscribe((res) => {
        this.zoneData = res["data"].cities;
        console.log("cityData", this.zoneData);
      });
    }
  }


}
